/**
 * Enum for consent preferred time options
 */
export enum ConsentPreferredTime {
  MORNING = 'morning',
  EVENING = 'evening',
  NO_PREFERENCE = 'no-preference'
}

/**
 * Labels for the consent preferred time options
 */
export const ConsentPreferredTimeLabels: Record<ConsentPreferredTime, string> = {
  [ConsentPreferredTime.MORNING]: 'Matin',
  [ConsentPreferredTime.EVENING]: 'Après-midi',
  [ConsentPreferredTime.NO_PREFERENCE]: 'Aucune préférence',
};
